var _circle, _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAshIcDetail(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    fill: "#E2E8F3"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.3186 6.3999L19.0386 16.6238C14.7474 18.352 9.88989 18.352 5.59863 16.6238L12.3186 6.3999Z",
    fill: "#818CA7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.79883 17.5169C12.2 18.2699 15.7862 17.9675 19.0388 16.6098L12.9588 7.35986C16.6276 15.0571 12.5353 16.5427 9.6135 17.2979C9.32306 17.373 9.0483 17.444 8.79883 17.5169Z",
    fill: "#56617B"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAshIcDetail);
export default __webpack_public_path__ + "static/media/ash-ic-detail.01161a51fb83bb7b3ad366190fbbf6cb.svg";
export { ForwardRef as ReactComponent };